import { render, staticRenderFns } from "./Claimants.vue?vue&type=template&id=3b771961&scoped=true"
import script from "./Claimants.vue?vue&type=script&lang=js"
export * from "./Claimants.vue?vue&type=script&lang=js"
import style0 from "./Claimants.vue?vue&type=style&index=0&id=3b771961&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b771961",
  null
  
)

export default component.exports